import { render, staticRenderFns } from "./travel-insurance-form-step-2.vue?vue&type=template&id=6cb03cde&scoped=true"
import script from "./travel-insurance-form-step-2.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-form-step-2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-form-step-2.vue?vue&type=style&index=0&id=6cb03cde&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb03cde",
  null
  
)

export default component.exports